import React, { useState } from "react";
import CustomQueryTable from "./CustomQueryTable.tsx";
import EvidenceRequestTable from "./EvidenceRequestTable.tsx";
import axios from "axios";
import { toast } from "../../components/Toast/toast.ts";
import { useClientQueryContext } from '../../context/ClientQueryContext.tsx';
import { useUserContext } from "../../context/UserContext.tsx";
import DescriptionBox from "../../components/DescriptionBox/index.tsx";
import { SegmentedControl } from "../../components/SegmentedControl/index.ts";

const options = [
  { value: "evidence-request-query", label: "Evidence-Request Queries" },
  { value: "custom-request-query", label: "Custom-Request Queries" },
];

const ClientQuery: React.FC = () => {

  const { reloadClientQueries } = useClientQueryContext();
  const [selectedValue, setSelectedValue] = useState("evidence-request-query");
  const [customQueryData, setCustomQueryData] = useState([]);
  const [evidenceRequestData, setEvidenceRequestData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAllCustomQueryDataFetched, setIsAllCustomQueryDataFetched] = useState(false);
  const [isAllEvidenceRequestDataFetched, setIsAllEvidenceRequestDataFetched] = useState(false);
  const { globalstorevalue } = useUserContext();

  const handleRadioChange = (value: string) => {
    setSelectedValue(value);
  };

  const fetchCustomRequestData = async () => {
    const storedToken = localStorage.getItem("token");
    try {
      if (storedToken) {
        setLoading(true);
        const [response1, response2] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/api/cust-portal/native/custom-query-request?${globalstorevalue ? `&stores=${globalstorevalue}` : ""}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              }
            }),
          axios.get(`${process.env.REACT_APP_API_URL}/api/cust-portal/native/evidence-request?${globalstorevalue ? `&stores=${globalstorevalue}` : ""}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              }
            })
        ])
        setCustomQueryData(response1?.data);
        setEvidenceRequestData(response2?.data);
        if (response1?.data?.length < 10) {
          setIsAllCustomQueryDataFetched(true);
        }
        if (response2?.data?.length < 10) {
          setIsAllEvidenceRequestDataFetched(true);
        }
        setLoading(false);
      }
    }
    catch (error: any) {
      toast.error(error?.response?.data?.message || error?.message || "Unable to retrieve client query data!");
      setLoading(false)
    }
  }

  React.useEffect(() => {
    fetchCustomRequestData();
    // eslint-disable-next-line
  }, [reloadClientQueries, globalstorevalue])

  return (
    <div className="flex flex-col gap-6">

      {/* Segmented Control */}
      <div className="flex justify-center">
        <SegmentedControl
          options={options}
          value={selectedValue}
          onChange={handleRadioChange}
        />
      </div>

      {/* Table Content */}
      <div>
        {selectedValue === "custom-request-query" ?
          <CustomQueryTable
            customQueryData={customQueryData}
            setCustomQueryData={setCustomQueryData}
            loading={loading}
            setLoading={setLoading}
            isAllCustomQueryDataFetched={isAllCustomQueryDataFetched}
            setIsAllCustomQueryDataFetched={setIsAllCustomQueryDataFetched}
          />
          :
          <EvidenceRequestTable
            evidenceRequestData={evidenceRequestData}
            loading={loading}
            setLoading={setLoading}
            setEvidenceRequestData={setEvidenceRequestData}
            isAllEvidenceRequestDataFetched={isAllEvidenceRequestDataFetched}
            setIsAllEvidenceRequestDataFetched={setIsAllEvidenceRequestDataFetched}
          />
        }
      </div>
    </div>
  )
}

export default ClientQuery;
